export const idtPrerequisites = [
  'IDENTITYTRUST',
  'IDENTITY_DOCUMENT_REQUIRED',
  'DOCUMENT_AND_LIVE_PHOTO_REQUIRED',
  'LIVE_PHOTO_REQUIRED',
]
